import * as CSS from "csstype"
import { system } from "styled-system"

const objectFit = system({
  objectFit: true,
})

export interface ObjectFitProps {
  objectFit?: CSS.Property.ObjectFit
}

export default objectFit
